import { SITE, NAV_LINKS } from "@/lib/site";
import { FaWhatsapp, FaInstagram, FaFacebookF } from "react-icons/fa";
import { ArrowUpRight } from "lucide-react";

const SOCIAL = [
  {
    name: "Instagram",
    href: "https://instagram.com/clamignon.cl",
    Icon: FaInstagram,
    testid: "social-instagram",
    hover: "hover:bg-gradient-to-tr hover:from-[#F58529] hover:via-[#DD2A7B] hover:to-[#8134AF] hover:text-white hover:border-transparent",
  },
  {
    name: "Facebook",
    href: "https://facebook.com/clamignon.cl",
    Icon: FaFacebookF,
    testid: "social-facebook",
    hover: "hover:bg-[#1877F2] hover:text-white hover:border-transparent",
  },
];

export default function Footer() {
  const year = new Date().getFullYear();
  const waHref = `https://wa.me/${SITE.whatsapp.number}?text=${encodeURIComponent(SITE.whatsapp.message)}`;
  return (
    <footer
      data-testid="site-footer"
      className="relative mt-8 md:mt-16"
    >
      <div className="max-w-[1160px] mx-auto px-4 md:px-6 pb-8">
        <div className="card-glass p-8 md:p-14 rounded-[36px] md:rounded-[44px]">
          <div className="grid grid-cols-12 gap-8">
            <div className="col-span-12 md:col-span-5">
              <img
                src={SITE.logoUrl}
                alt="Clamignon"
                className="h-28 md:h-32 w-auto object-contain mb-6"
              />
              <p className="font-display text-2xl md:text-3xl font-bold text-[#0B0B14] tracking-tight leading-[1.15] max-w-sm">
                Distribuidor autorizado Clamignon® Chile.
              </p>
              <p className="mt-4 text-[#3A3A48] max-w-sm text-sm md:text-base">
                Beauty Technology by AEGENBIO. Fabricado en Corea. Aprobado por ISP
                Chile como Dispositivo Médico.
              </p>

              {/* Social buttons */}
              <div className="mt-8 flex items-center gap-3" data-testid="social-buttons">
                {SOCIAL.map((s) => (
                  <a
                    key={s.name}
                    href={s.href}
                    target="_blank"
                    rel="noreferrer"
                    aria-label={s.name}
                    data-testid={s.testid}
                    className={`w-11 h-11 rounded-full bg-white/80 backdrop-blur border border-black/[0.08] flex items-center justify-center text-[#0B0B14] transition-all duration-300 hover:-translate-y-0.5 ${s.hover}`}
                  >
                    <s.Icon className="w-4 h-4" />
                  </a>
                ))}
                <a
                  href={waHref}
                  target="_blank"
                  rel="noreferrer"
                  aria-label="WhatsApp"
                  data-testid="social-whatsapp"
                  className="w-11 h-11 rounded-full bg-white/80 backdrop-blur border border-black/[0.08] flex items-center justify-center text-[#0B0B14] transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#25D366] hover:text-white hover:border-transparent"
                >
                  <FaWhatsapp className="w-4 h-4" />
                </a>
              </div>
            </div>

            <div className="col-span-6 md:col-span-3">
              <p className="text-[11px] font-semibold uppercase tracking-widest text-[#5A48C9] mb-4">
                Secciones
              </p>
              <ul className="space-y-2">
                {NAV_LINKS.map((l) => (
                  <li key={l.id}>
                    <a href={`#${l.id}`} className="text-[#1E1E2C] hover:text-[#7C6AF5] transition-colors">
                      {l.label}
                    </a>
                  </li>
                ))}
                <li>
                  <a href="#contacto" className="text-[#1E1E2C] hover:text-[#7C6AF5] transition-colors">
                    Contacto
                  </a>
                </li>
              </ul>
            </div>

            <div className="col-span-6 md:col-span-4">
              <p className="text-[11px] font-semibold uppercase tracking-widest text-[#5A48C9] mb-4">
                Contacto
              </p>
              <ul className="space-y-2 text-sm">
                <li>
                  <a
                    href={`https://wa.me/${SITE.whatsapp.number}`}
                    target="_blank"
                    rel="noreferrer"
                    className="inline-flex items-center gap-2 text-[#1E1E2C] hover:text-emerald-600 transition-colors"
                  >
                    <FaWhatsapp className="w-4 h-4" /> {SITE.whatsapp.display}
                  </a>
                </li>
                <li>
                  <a
                    href={`mailto:${SITE.email}`}
                    className="text-[#1E1E2C] hover:text-[#7C6AF5] transition-colors"
                  >
                    {SITE.email}
                  </a>
                </li>
                <li className="text-[#6B6B7D]">{SITE.city}</li>
                <li>
                  <a
                    href={SITE.brochureUrl}
                    target="_blank"
                    rel="noreferrer"
                    data-testid="footer-brochure-link"
                    className="inline-flex items-center gap-1 text-[#5A48C9] hover:text-[#7C6AF5] transition-colors font-semibold"
                  >
                    Ver ficha técnica <ArrowUpRight className="w-3.5 h-3.5" />
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-black/[0.08] flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-[11px] font-semibold uppercase tracking-widest text-[#6B6B7D]">
            <p>© {year} Clamignon Chile · Distribuidor Autorizado</p>
            <div className="flex flex-wrap items-center gap-x-4 gap-y-1">
              <span>ISP · Dispositivo Médico</span>
              <span className="hidden md:inline">·</span>
              <span>ISO 13485 · KGMP</span>
              <span className="hidden md:inline">·</span>
              <span>Made in Korea</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
